"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Screen = void 0;

var inherits_1 = __importDefault(require("inherits"));

var page_1 = require("./page");

var track_1 = require("./track");

function Screen(dictionary, opts) {
  page_1.Page.call(this, dictionary, opts);
}

exports.Screen = Screen;
inherits_1.default(Screen, page_1.Page);

Screen.prototype.action = function () {
  return "screen";
};

Screen.prototype.type = Screen.prototype.action;

Screen.prototype.event = function (name) {
  return name ? "Viewed " + name + " Screen" : "Loaded a Screen";
};

Screen.prototype.track = function (name) {
  var json = this.json();
  json.event = this.event(name);
  json.timestamp = this.timestamp();
  json.properties = this.properties();
  return new track_1.Track(json, this.opts);
};